








































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import ResultDistributionTab from "../../components/ResultDistributionTab.vue";
import { Sheet, Curriculum, Distribution } from "../../modules/teacher/ResultDistributionList"


export interface Data {
  sheet_group_key: string
  room_id: string
  student_num: string
  nendo: string
  curriculums: Curriculum[]
  ratingRange: string[]
  sheet: Sheet
  distribution_data: any
  student_result: any
  isStudentSite: boolean
  KindEnum: Readonly<{TwentyMin: number; Various: number; Kimatsu: number}>
  col_count: number
  errors: string[]
}

export default defineComponent({
  components: {
    "result-distribution-tab": ResultDistributionTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * ref
     ******************************/

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sheet_group_key: "",
      room_id: "",
      student_num: "",
      nendo: "",
      curriculums: new Array<Curriculum>(),
      ratingRange: ["10", "9", "8", "7", "6", "5", "4", "3", "2", "1", "0"],
      sheet: new Sheet({}),
      distribution_data: {},
      student_result: {},
      isStudentSite: window.location.href.indexOf("student_site") != -1,
      KindEnum: Common.KindEnum,
      col_count: 20,
      errors: [],
    });

    const total_ratings = computed((): any[] => {
      return chunk(state.distribution_data.total_ratings, state.col_count);
    });

    const toBack = () => {
      if(!state.student_num){
        context.root.$router.push(`/teacher_site/result_student_list/${state.sheet_group_key}/${context.root.$store.state.resultDistributionRoomId}`).catch(() => {});
      }else if(!state.isStudentSite){
        context.root.$router.push(`/teacher_site/result_student_twenty`).catch(() => {});
      }else{
        context.root.$router.push({path: `/student_site/result_student_twenty`, query: {nendo: state.nendo}}).catch(() => {});
      }
    };

    const parseRate = (rate: any) => {
      return rate ? rate + "%" : "-";
    };

    const backColorRating = (rating: string, curriculum_id: number) => {
      let headerClass = {};
      if(state.student_result && state.student_result[curriculum_id] == rating){
        headerClass = {mcolor: true};
      }
      return headerClass;
    };

    const backColorTotal = (rating: string) => {
      let headerClass = {};
      if(state.student_result && state.student_result["total"] == rating){
        headerClass = {mcolor: true};
      }
      return headerClass;
    };

    /******************************
     * 配列を一定の個数毎に分割
     ******************************/

    const chunk = (arr: any[], size: number) => {
      return arr.reduce((newarr, _, i) => (i % size ? newarr : [...newarr, arr.slice(i, i + size)]), [])
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      state.sheet_group_key = context.root.$route.params.sheet_group_key;
      state.room_id = context.root.$route.params.room_id;
      state.student_num = context.root.$store.state.student_num ? context.root.$store.state.student_num.toString() : "";
      state.nendo = context.root.$route.query.nendo ? context.root.$route.query.nendo.toString() : "";
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/result_distribution_list?sheet_group_key=${state.sheet_group_key}&room_id=${state.room_id}&student_num=${state.student_num}`).then(response => {
        state.sheet = new Sheet(response.data.sheet);
        state.curriculums = response.data.curriculums.map((x: any) => new Curriculum(x));
        state.distribution_data = response.data.distribution_data;
        state.student_result = response.data.student_result;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      total_ratings,
      toBack,
      parseRate,
      backColorRating,
      backColorTotal,
    }
  }
});
